import { call, put, select, takeEvery } from 'redux-saga/effects';

import { isAuthenticatedSelector, onboardingSlice } from '»components/Auth';
import { disclaimersServices } from '»components/molecules/TrlDisclaimer';
import { handleSagaError } from '»utils/handleSagasError';

import { dbConfigurationsServices } from './dbConfigurations.services';
import { dbConfigurationsSlice } from './dbConfigurations.slice';

const getDbConfigurationsWorker = function* ({ payload }) {
  try {
    const { detailIds, parameterId, noAuth, iban, iban2 } = payload;

    const isAuthenticated = yield select(isAuthenticatedSelector);

    const dbConfigurations = yield call(
      noAuth
        ? dbConfigurationsServices.dbConfigurationsNoAuth
        : dbConfigurationsServices.dbConfigurations,
      { parameterId },
    );

    if (
      parameterId === 'CR_CHNN_ONBOARD_PS' ||
      parameterId === 'CR_CHNN_ONBOARD_PC'
    ) {
      yield put(
        onboardingSlice.actions.getMainFormFieldsSuccess({
          dbConfigurations,
          formPreviousInfo: payload.formPreviousInfo,
          iban,
          iban2,
        }),
      );
      yield put(onboardingSlice.actions.getClassifDescriptionsRequest());
    } else {
      const usefulDbConfigurations = dbConfigurations.filter((config) =>
        detailIds.includes(config.detailId),
      );

      yield put(
        dbConfigurationsSlice.actions.dbConfigurationsSucess(
          usefulDbConfigurations,
        ),
      );

      if (!isAuthenticated) {
        const filteredConfigs = usefulDbConfigurations.filter(
          (config) =>
            config.detailId === 'ONBOARDING' ||
            config.detailId === 'ONBOARDING_DATA_ACCEPT',
        );

        const mustAllowDataProcessing =
          filteredConfigs.length === 2
            ? filteredConfigs.every((config) => config.value === 'Y')
            : false;

        if (mustAllowDataProcessing) {
          const disclaimerResponse = yield call(
            disclaimersServices.getDisclaimerNoAuth,
            { context: 'ONBOARDING_ACCEPT' },
          );
          yield put(
            onboardingSlice.actions.setCreateAccountDisclaimer({
              disclaimer: disclaimerResponse[0]?.body,
            }),
          );
        }
      }
    }
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled)
      yield put(dbConfigurationsSlice.actions.dbConfigurationsFailure());
  }
};

export const dbConfigurationsSagas = function* () {
  yield takeEvery(
    dbConfigurationsSlice.actions.dbConfigurationsRequest.type,
    getDbConfigurationsWorker,
  );
};
